import { render, staticRenderFns } from "./UserResult.vue?vue&type=template&id=369d85fc&scoped=true"
import script from "./UserResult.vue?vue&type=script&lang=js"
export * from "./UserResult.vue?vue&type=script&lang=js"
import style0 from "./UserResult.vue?vue&type=style&index=0&id=369d85fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369d85fc",
  null
  
)

export default component.exports